import { useEffect } from 'react';

/**
 * Bloquea el scroll del <body> mientras `activo` sea true (p. ej. cuando hay un
 * modal abierto), y lo restaura al cerrar o desmontar. Usa un contador global
 * para soportar varios modales apilados: el scroll solo se restaura cuando se
 * cierra el último.
 *
 * @param {boolean} activo  true para bloquear el scroll de la página de debajo.
 */
let contador = 0;
let overflowPrevio = '';

export default function useLockBodyScroll(activo = true) {
  useEffect(() => {
    if (!activo || typeof document === 'undefined') return undefined;

    if (contador === 0) {
      overflowPrevio = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    contador += 1;

    return () => {
      contador -= 1;
      if (contador === 0) {
        document.body.style.overflow = overflowPrevio;
      }
    };
  }, [activo]);
}
